import { scrollToId } from "@/lib/scroll";
import { MAILTO } from "@/lib/site";

export const Nav = ({ onSelectAudience, onOpenTechnology }) => {
  const go = (id, audience) => {
    if (audience && onSelectAudience) onSelectAudience(audience);
    if (id === "#technology" && onOpenTechnology) onOpenTechnology();
    scrollToId(id);
  };

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 h-16 bg-[#F5F4F0]/85 backdrop-blur-md border-b border-[#E2DFD7]"
    >
      <div className="max-w-7xl mx-auto h-full px-6 sm:px-8 lg:px-12 flex items-center justify-between">
        <button
          data-testid="nav-brand-logo"
          onClick={() => go("#hero")}
          className="flex items-center group"
        >
          <img
            src="/assets/lockup-side-mono-ink.png"
            alt="Shikra Energy"
            className="h-10 w-auto group-hover:opacity-70 transition-opacity duration-300"
          />
        </button>
        <nav className="hidden lg:flex items-center gap-7">
          <button
            data-testid="nav-link-for-ci"
            onClick={() => go("#what-we-do", "ci")}
            className="text-sm text-[#4A4D4A] hover:text-[#121413] transition-colors duration-300"
          >
            For EPC/Integrators
          </button>
          <button
            data-testid="nav-link-for-utilities"
            onClick={() => go("#what-we-do", "utilities")}
            className="text-sm text-[#4A4D4A] hover:text-[#121413] transition-colors duration-300"
          >
            For Utilities
          </button>
          <button
            data-testid="nav-link-technology"
            onClick={() => go("#technology")}
            className="text-sm text-[#4A4D4A] hover:text-[#121413] transition-colors duration-300"
          >
            Technology
          </button>
          <button
            data-testid="nav-link-team"
            onClick={() => go("#team")}
            className="text-sm text-[#4A4D4A] hover:text-[#121413] transition-colors duration-300"
          >
            Team
          </button>
          <button
            data-testid="nav-link-contact"
            onClick={() => go("#contact")}
            className="text-sm text-[#4A4D4A] hover:text-[#121413] transition-colors duration-300"
          >
            Contact
          </button>
        </nav>
        <a
          data-testid="nav-iitm-credibility-mark"
          href="https://www.iitm.ac.in"
          target="_blank"
          rel="noopener noreferrer"
          title="Born at SenAI Labs, IIT Madras"
          className="flex items-center gap-3 group"
        >
          <span className="hidden md:block font-sans font-semibold text-[11px] uppercase tracking-[0.14em] leading-snug text-[#121413] group-hover:text-[#2C4A3A] transition-colors duration-300 text-right">
            Born at SenAI Labs
            <br />
            IIT Madras
          </span>
          <img
            src="/assets/iitm-emblem.png"
            alt="IIT Madras emblem"
            className="h-9 w-auto group-hover:opacity-70 transition-opacity duration-300"
          />
        </a>
      </div>
    </header>
  );
};
